import { render } from "./zhenggaozhongyi-news.vue?vue&type=template&id=071a4f73&scoped=true"
import script from "./zhenggaozhongyi-news.vue?vue&type=script&lang=js"
export * from "./zhenggaozhongyi-news.vue?vue&type=script&lang=js"

import "./zhenggaozhongyi-news.vue?vue&type=style&index=0&id=071a4f73&lang=less&scoped=true"

import exportComponent from "G:\\PRO\\fuvview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071a4f73"]])

export default __exports__